import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    expenses: [], // Array of trend data points
    business: null,
    summary: {
      totalExpenses: 0,
      totalAmount: 0,
      dateRange: {
        from: "",
        to: "",
      },
      frequency: "monthly",
    },
    filters: {
      startDate: "",
      endDate: "",
      frequency: "monthly",  
    },
  },
  loading: false,
  error: null,
};

const expenseTrendReportSlice = createSlice({
  name: "expenseTrendReport",
  initialState,
  reducers: {
    fetchExpenseTrendRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchExpenseTrendSuccess(state, action) {
      state.loading = false;
      state.data = {
        ...state.data,
        ...action.payload, // Replace with full payload from API
      };
    },
    fetchExpenseTrendFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetExpenseTrendReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    },
    updateExpenseTrendFilters(state, action) {
      state.data.filters = {
        ...state.data.filters,
        ...action.payload,
      };
    },
  },
});

// Destructure and export actions
export const {
  fetchExpenseTrendRequest,
  fetchExpenseTrendSuccess,
  fetchExpenseTrendFailure,
  resetExpenseTrendReport,
  updateExpenseTrendFilters,
} = expenseTrendReportSlice.actions;

// Export reducer
export default expenseTrendReportSlice.reducer;
